import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteAttachment } from 'action/article'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const generateModalText = (title) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${title}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${title} has been successfully deleted`
    },
    title: {
      error: `There has been an issue deleting ${title}`,
      success: 'Attachment deleted'
    }
  }
})

const DeleteAttachment = ({ deleteAttachment, attachment: { uuid, file_name: title }, pagination }) => {
  const handleSubmit = () => deleteAttachment(uuid)

  const { decide, outcome } = generateModalText(title)

  return (
    <a onClick={() => confirmModal(handleSubmit, decide, outcome)}>Delete Attachment</a>
  )
}

DeleteAttachment.propTypes = {
  attachment: PropTypes.object,
  deleteAttachment: PropTypes.func,
  pagination: PropTypes.object
}

const mapDispatchToProps = (dispatch) => ({
  deleteAttachment: bindActionCreators(deleteAttachment, dispatch)
})

const mapStateToProps = (state) => ({
  pagination: state.dataset.pagination
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteAttachment)
